const role = {
	Admin: 1,
	User: 3,
	CityAdmin: 2,
	TerminalAdmin: 4,
};

module.exports = { role };
